import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w-100 view-tenant-review-report" }
const _hoisted_2 = { class: "row details" }
const _hoisted_3 = { class: "col-lg-12 pb-5" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "title d-block" }, "Location", -1)
const _hoisted_5 = { class: "sub-text d-block" }
const _hoisted_6 = { class: "col-lg-4 col-md-4 col-6 pb-5" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "title d-block" }, "Move In Date", -1)
const _hoisted_8 = { class: "sub-text d-block" }
const _hoisted_9 = { class: "col-lg-4 col-md-4 col-6 pb-5" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "title d-block" }, "Move Out Date", -1)
const _hoisted_11 = { class: "sub-text d-block" }
const _hoisted_12 = { class: "col-lg-4 col-md-4 col-6" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "title d-block" }, "Date Submitted", -1)
const _hoisted_14 = { class: "sub-text d-block" }
const _hoisted_15 = {
  key: 0,
  class: "alert alert-primary",
  role: "alert"
}
const _hoisted_16 = { class: "ratings-overview d-flex justify-content-between pt-5" }
const _hoisted_17 = { class: "row w-100" }
const _hoisted_18 = { class: "col-lg-4 col-md-4 col-6" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Overall Rating", -1)
const _hoisted_20 = { class: "col-lg-4 col-md-4 col-6" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "title d-block" }, "Rent Per Week", -1)
const _hoisted_22 = { class: "title d-block" }
const _hoisted_23 = {
  key: 1,
  class: "btn-actions d-flex mt-6"
}
const _hoisted_24 = { class: "row no-gutters w-100" }
const _hoisted_25 = { class: "col-lg-4 col-md-4 offset-lg-5 offset-md-5" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", { class: "fas fa-envelope" }, null, -1)
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" Email Report ")
const _hoisted_28 = [
  _hoisted_26,
  _hoisted_27
]
const _hoisted_29 = { class: "col-lg-3 col-md-3" }
const _hoisted_30 = { class: "dropdown d-inline-block btn-download w-100" }
const _hoisted_31 = ["data-kt-indicator"]
const _hoisted_32 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fas fa-download" }),
  /*#__PURE__*/_createTextVNode(" Download ")
], -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode("Downloading... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_34 = [
  _hoisted_32,
  _hoisted_33
]
const _hoisted_35 = { class: "dropdown-menu" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("a", {
  class: "dropdown-item",
  href: "#"
}, "Download Ledger", -1)
const _hoisted_37 = [
  _hoisted_36
]
const _hoisted_38 = /*#__PURE__*/_createElementVNode("a", {
  class: "dropdown-item",
  href: "#"
}, "Download Report", -1)
const _hoisted_39 = [
  _hoisted_38
]
const _hoisted_40 = { class: "ratings" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Report", -1)
const _hoisted_42 = { class: "me-3" }
const _hoisted_43 = { class: "d-block" }
const _hoisted_44 = {
  key: 0,
  class: "col-sm-6 col-6 col-lg-4 col-md-4"
}
const _hoisted_45 = {
  key: 1,
  class: "col-sm-6 col-6 col-lg-4 col-md-4"
}
const _hoisted_46 = {
  key: 2,
  class: "col-12"
}
const _hoisted_47 = { class: "text-answer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_rate = _resolveComponent("el-rate")!
  const _component_EmailReportModal = _resolveComponent("EmailReportModal")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_NoReviewSubmitted = _resolveComponent("NoReviewSubmitted")!
  const _component_LedgerReport = _resolveComponent("LedgerReport")!
  const _component_PDFGenerator = _resolveComponent("PDFGenerator")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.address), 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.dateFormat(_ctx.currentTenantReview?.move_in_date)), 1)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.dateFormat(_ctx.currentTenantReview?.move_out_date)), 1)
      ]),
      _createElementVNode("div", _hoisted_12, [
        _hoisted_13,
        _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.dateFormat(_ctx.currentTenantReview?.date_created)), 1)
      ])
    ]),
    (
        _ctx.isMoveDateGreaterThanCreatedDate &&
        _ctx.currentTenantReview?.status === 'published'
      )
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, " Tenant is due to vacate the property on " + _toDisplayString(_ctx.dateFormat(_ctx.currentTenantReview?.move_out_date)), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, [
          _hoisted_19,
          _createVNode(_component_el_rate, {
            class: "review-ans-avrg",
            "model-value": _ctx.currentTenantReview?.average_rating,
            disabled: "",
            "allow-half": ""
          }, null, 8, ["model-value"])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _hoisted_21,
          _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.rentPerWeek), 1)
        ])
      ]),
      _createVNode(_component_EmailReportModal, {
        modelValue: _ctx.sendReport,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.sendReport) = $event)),
        onSend: _ctx.emailReport,
        ref: "emailReport",
        loading: _ctx.sendingReport
      }, null, 8, ["modelValue", "onSend", "loading"])
    ]),
    (_ctx.currentTenantReview?.status === 'published')
      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("button", {
                class: "btn btn-lg btn-new-design-primary btn-email w-100 d-inline-block mb-lg-0 mb-md-0 mb-3",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleSendReport && _ctx.handleSendReport(...args)))
              }, _hoisted_28)
            ]),
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("button", {
                  class: "btn btn-new-design-secondary dropdown-toggle w-100",
                  "data-kt-indicator": _ctx.generatingReport ? 'on' : null,
                  type: "button",
                  "data-bs-toggle": "dropdown",
                  "aria-expanded": "false"
                }, _hoisted_34, 8, _hoisted_31),
                _createElementVNode("ul", _hoisted_35, [
                  _createElementVNode("li", {
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.download('ledger')))
                  }, _hoisted_37),
                  _createElementVNode("li", {
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.download('report')))
                  }, _hoisted_39)
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_40, [
      (
          _ctx.currentTenantReview?.status === 'published' &&
          _ctx.currentTenantReview?.is_not_reviewed === 'no'
        )
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _hoisted_41,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentTenantReview?.review_answers, (answer, key) => {
              return (_openBlock(), _createElementBlock("div", {
                key: key,
                class: "rating-item w-100 row"
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass(["text col-sm-6 col-6 col-lg-8 col-md-8 d-flex", { 'col-12': answer.type === 'textbox' }])
                }, [
                  _createElementVNode("div", _hoisted_42, _toDisplayString(key + 1) + ".)", 1),
                  _createElementVNode("span", _hoisted_43, _toDisplayString(answer.question), 1)
                ], 2),
                (answer.type === 'rating')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                      _createVNode(_component_el_form_item, {
                        prop: answer.id
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_rate, {
                            disabled: "",
                            size: "small",
                            class: "rating-size",
                            modelValue: answer.answer,
                            "onUpdate:modelValue": ($event: any) => ((answer.answer) = $event)
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 2
                      }, 1032, ["prop"])
                    ]))
                  : (answer.type === 'radio')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                        _createElementVNode("span", {
                          class: _normalizeClass(["badge", _ctx.getColor(answer.answer)])
                        }, _toDisplayString(answer?.answer), 3)
                      ]))
                    : (answer.type === 'textbox')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                          _createElementVNode("div", _hoisted_47, _toDisplayString(answer?.answer?.length == 0 ? '' : answer.answer), 1)
                        ]))
                      : _createCommentVNode("", true)
              ]))
            }), 128))
          ], 64))
        : _createCommentVNode("", true),
      (
          _ctx.currentTenantReview?.status === 'published' &&
          _ctx.currentTenantReview?.is_not_reviewed === 'yes'
        )
        ? (_openBlock(), _createBlock(_component_NoReviewSubmitted, { key: 1 }))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_PDFGenerator, {
      onGeneratingReport: _cache[4] || (_cache[4] = ($event: any) => (_ctx.generatingReport = true)),
      onGeneratedReport: _cache[5] || (_cache[5] = ($event: any) => (_ctx.generatingReport = false)),
      orientation: "portrait",
      "file-name": "Report",
      ref: "pdfReport"
    }, {
      content: _withCtx(() => [
        _createVNode(_component_LedgerReport, {
          "average-rating": _ctx.averageRating,
          info: _ctx.currentTenantReview,
          map: _ctx.googleStaticMapImageSrc,
          reviews: _ctx.reviewsCount
        }, null, 8, ["average-rating", "info", "map", "reviews"])
      ]),
      _: 1
    }, 512)
  ]))
}